import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Profil.css";
import EvrakPopup from "./EvrakPopup";
import CropperPopup from "../components/CropperPopup";
import getCroppedImg from "../components/cropImage";

const AdayProfil = () => {
  const [basvurular, setBasvurular] = useState([]);
  const [ilanlar, setIlanlar] = useState([]);
  const [mulakatlar, setMulakatlar] = useState([]);
  const [showEvrakPopup, setShowEvrakPopup] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [photoFile, setPhotoFile] = useState(null);
  const [showFullPhoto, setShowFullPhoto] = useState(false);
  const [cropImageUrl, setCropImageUrl] = useState(null);
  const [showCropper, setShowCropper] = useState(false);

  const kullaniciAdi = localStorage.getItem("userName") || "Kullanıcı";
  const kullaniciMail = localStorage.getItem("userEmail") || "E-posta";
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchIlanlar();
    fetchBasvurular();
    fetchMulakatlar();
    fetchPhoto();
  }, []);

  const fetchIlanlar = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Ilan/getirhepsi`);
      setIlanlar(res.data.$values || []);
    } catch (err) {
      console.error("❌ İlanlar alınamadı:", err);
    }
  };

  const fetchBasvurular = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Basvuru/basvurularim`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBasvurular(res.data.$values || []);
    } catch (err) {
      console.error("❌ Başvurular alınamadı:", err);
    }
  };

  const fetchMulakatlar = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Mulakat/getirhekullanici`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMulakatlar(res.data.$values || []);
    } catch (err) {
      console.error("❌ Mülakat verisi alınamadı:", err);
    }
  };

  const fetchPhoto = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      const imgUrl = URL.createObjectURL(res.data);
      setProfilePhoto(imgUrl);
    } catch (err) {
      console.error("❌ Profil fotoğrafı alınamadı:", err);
    }
  };

  const handleUploadPhoto = async () => {
    if (!photoFile) return alert("Lütfen bir fotoğraf seçin.");
    const formData = new FormData();
    formData.append("Foto", photoFile);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppyukle`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      alert("✅ Fotoğraf başarıyla yüklendi.");
      fetchPhoto();
    } catch (err) {
      console.error("❌ Fotoğraf yüklenemedi:", err);
      alert("❌ Fotoğraf yüklenemedi.");
    }
  };

  return (
    <div className="profil-modern-container">
      {/* Üst Bilgi */}
      <div className="profil-header">
        <div className="profil-avatar-wrapper">
          {profilePhoto ? (
            <>
              <img
                src={profilePhoto}
                alt="Profil"
                className="profil-avatar-img"
                onClick={() => setShowFullPhoto(true)}
                style={{ cursor: "pointer" }}
              />
              <button className="profil-edit-btn" onClick={() => document.getElementById("photoUpload").click()}>
                Fotoğrafı Değiştir
              </button>
            </>
          ) : (
            <>
              <div className="profil-avatar-empty"></div>
              <label htmlFor="photoUpload" className="upload-link">Profil fotoğrafı yükle</label>
            </>
          )}

          <input
            id="photoUpload"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => {
              const file = e.target.files[0];
              if (!file) return;

              const reader = new FileReader();
              reader.onloadend = () => {
                setCropImageUrl(reader.result);
                setShowCropper(true);
              };
              reader.readAsDataURL(file);
            }}
          />
        </div>

        <div className="profil-info">
          <h2>{kullaniciAdi}</h2>
          <p>{kullaniciMail}</p>
        </div>
      </div>

      {/* Başvurularım */}
      <section className="kullanici-profil-section">
        <h3>Başvurularım</h3>
        {basvurular.length === 0 ? (
          <p className="no-basvuru-mesaji">Henüz bir başvurunuz bulunmamaktadır.</p>
        ) : (
          <div className="basvuru-card-wrapper">
            {basvurular.map((item, index) => {
              const ilan = ilanlar.find(i => i.ilanId === item.ilanId);
              const ilgiliMulakat = mulakatlar.find(m => m.basvuruId === item.basvuruId);
              const basvuruSurecMap = {
                1: "İnceleme Bekleniyor",
                2: "Mülakat Bekleniyor",
                3: "Evrak Bekleniyor",
                4: "Onay Bekleniyor",
              };
              const durumAdi = basvuruSurecMap[item.basvuruSurecId] || "Beklemede";

              return (
                <div className="basvuru-card" key={index}>
                  <h4>
                    {ilan?.ilanBaslik || "Başlık Yok"}{ilan?.magazaAdi ? ` - ${ilan.magazaAdi}` : ""}
                  </h4>
                  <p>📍 {ilan?.ilanUlkelerAdi || "-"} / {ilan?.ilanillerAdi || "-"}</p>
                  <p>🧑‍💼 {ilan?.ilanPozisyonAdi || "-"}</p>
                  <p>📅 {new Date(item.basvuruTarihi).toLocaleDateString("tr-TR")}</p>
                  <p>📊 Durum: <strong>{durumAdi}</strong></p>

                  {ilgiliMulakat && (
                    <div className="mulakat-bilgisi">
                      <hr style={{ margin: "10px 0" }} />
                      <p>
                        📅 Mülakat Tarihi :{" "}
                        <strong>
                          {new Date(ilgiliMulakat.mulakatTarihi).toLocaleDateString("tr-TR")}{" "}
                          {new Date(ilgiliMulakat.mulakatTarihi).toLocaleTimeString("tr-TR", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </strong>
                      </p>
                      <p className="adres-tam">
                        📍 Adres: <strong>{ilgiliMulakat.mulakatAdresi}</strong>
                        <br />
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ilgiliMulakat.mulakatAdresi)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginLeft: "5px", color: "#d91e18" }}
                        >
                          Google haritalar
                        </a>{" "}
                        -{" "}
                        <a
                          href={`http://maps.apple.com/?q=${encodeURIComponent(ilgiliMulakat.mulakatAdresi)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginLeft: "5px", color: "#d91e18" }}
                        >
                          Apple haritalar
                        </a>
                      </p>
                      <p>
                        👤 Mülakatı Yapan :{" "}
                        <strong>
                          {ilgiliMulakat.mulakatYapanAd} {ilgiliMulakat.mulakatYapanSoyad}
                        </strong>
                      </p>
                      <p>
                        📞 İletişim : <strong>{ilgiliMulakat.mulakatYapanTelefon}</strong>
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </section>

      {showCropper && (
        <CropperPopup
          image={cropImageUrl}
          onCancel={() => setShowCropper(false)}
          onCropComplete={async (croppedBlob) => {
            setShowCropper(false);

            const formData = new FormData();
            formData.append("Foto", croppedBlob, "pp.jpg");

            try {
              await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppyukle`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${token}`,
                },
              });
              fetchPhoto();
            } catch (err) {
              console.error("❌ Fotoğraf yüklenemedi:", err);
            }
          }}
        />
      )}

      {showFullPhoto && (
        <div className="photo-modal-overlay" onClick={() => setShowFullPhoto(false)}>
          <div className="photo-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={profilePhoto} alt="Büyük Profil" />
            <span className="photo-modal-close" onClick={() => setShowFullPhoto(false)}>✖</span>
          </div>
        </div>
      )}

      {/* Evraklarım */}
      <section className="kullanici-profil-section">
        <h3>Evraklarım</h3>
        <button className="evrak-ekle-btn" onClick={() => setShowEvrakPopup(true)}>
          Evrak Ekle
        </button>
        {showEvrakPopup && <EvrakPopup onClose={() => setShowEvrakPopup(false)} />}
      </section>
    </div>
  );
};

export default AdayProfil;
